// Module
var code = "<div id=\"availabilityPanel{{vm.pageHash}}\"\n     ng-controller=\"availabiltypanel as vm\"\n     ng-init=\"vm.init(panel.obj,panel.filter)\">\n\n    <vx-availability></vx-availability>\n\n</div>";
// Exports
module.exports = code;